/* eslint-disable no-undef, indent */
import { Widget } from "blue-widgets";

class ContentListing extends Widget {
  constructor(el) {
    super(el);

    // content type: JobListing || QualificationsListing
    // default is QualificationsListing
    this.contentType =
      this.el.getAttribute("data-content-type") || "QualificationsListing";

    // page data
    if (this.contentType === "JobListing") {
      this.listings = jobPosts || [];
      this.provinceFilters = provinceFilters || [];
    } else {
      this.listings = qualifications || [];
      this.campusFilters = campusFilters || [];
    }
    this.industryFilters = industryFilters || [];
    this.courseTypeFilters = courseTypeFilters || [];
    this.facultyFilters = facultyFilters || [];
    this.listingsPerPage = qualificationsPerPage || 6;

    // page elements
    this.filters = document.querySelector("[data-filters]");
    this.mobileFilters = document.querySelector("[data-mobile-filters]");

    this.foundText = this.el.querySelector("[data-found");
    this.sortSelect = this.el.querySelector("[data-card-sort]");
    this.mobileTrigger = this.el.querySelector("[data-mobile-trigger]");
    this.mobileMenu = document.querySelector("[data-mobile-filters-menu]");
    this.mobileApply = document.querySelector("[data-mobile-filters-apply]");
    this.results = this.el.querySelector("[data-filtered-content]");
    this.chiplist = this.el.querySelector("[data-chip-list]");
    this.chipListMobile = this.mobileMenu.querySelector("[data-chip-list]");
    this.pagination = this.el.querySelector("[data-pagination]");
    this.dataClearFilters = document.querySelectorAll("[data-clear-filters]");
    this.closeFiltersBtn = document.querySelector("[data-close-filters]");
    this.h4Title = this.el.querySelector("[data-filter-h4]");
    this.h4TitleMobile = this.mobileMenu.querySelector("[data-filter-h4]");
    this.h6Title = this.el.querySelector("[data-filter-h6]");
    this.h6TitleMobile = this.mobileMenu.querySelector("[data-filter-h6]");

    this.currentPage = 1;
    this.scrollPos = 0;

    this.tempFilterSelection = {};
    this.filterSelection = {};

    this.filteredListings = [...this.listings];
    this.sort = "A-Z";
    if (this.contentType === "JobListing") {
      this.filterList = ["Province", "Industry", "CourseType", "Faculty"];
    } else {
      this.filterList = ["Campus", "Industry", "CourseType", "Faculty"];
    }
    this.toggleMobileMenuHandler = this.toggleMobileMenuHandler.bind(this);

    this.init();
  }

  createChip = (group, label, { isMobile = false }) => {
    const liElement = document.createElement("li");
    if (isMobile) {
      liElement.setAttribute("id", `filterchip-mobile-${label}`);
    } else {
      liElement.setAttribute("id", `filterchip-${label}`);
    }

    const button = document.createElement("button");
    button.classList.add("button--pill", "pill", "pill--grey2");
    button.setAttribute("aria-label", `Click to remove ${label} filter`);

    const span = document.createElement("span");
    span.textContent = label;

    const icon = document.createElement("i");
    icon.classList.add("icon", "icon-close");
    icon.setAttribute("aria-hidden", "true");
    icon.addEventListener("click", () => {
      this.chipClickHandler(group, label);
    });
    button.appendChild(span);
    button.appendChild(icon);

    liElement.appendChild(button);
    return liElement;
  };

  createCard = (data) => {
    // Job Listing card
    if (this.contentType === "JobListing") {
      return `
      <div
        class="card card--qualification card--qualification-horiz card--job-listing"
        data-widget="CardTruncate"
      >
        <div class="card--qualification__inner">
          <div>
            <p class="pill pill--blue">${data.Faculty}</p>
            <a
              class="h3 card--qualification__title"
              href="${data.Link.Url}"
              target="${data.Link.target || "_self"}"
            >
              ${data.Title}
            </a>
            <p class="card__body" data-body="">${data.Description}</p>
          </div>
          <div>
            <ul class="pill-container">
              <li class="pill pill--grey2">
                <i class="icon icon-Timer" aria-hidden="true"></i>
                <span>${this.formatDate(data.EndDate)}</span>
              </li>
             ${data.Industries.map((item) => {
               return `
                <li class="pill pill--grey2">
                  <i class="icon icon-award" aria-hidden="true"></i>
                  <span>${item}</span>
                </li> 
                `;
             }).join("")}
              <li class="pill pill--grey2">
                <i class="icon icon-globe" aria-hidden="true"></i>
                <span>${data.Province}</span>
              </li> 
            </ul>
            <div class="spacer-base"></div>
            <a
              class="card__link"
              href="${data.Link.Url}"
              title="${data.Link.Name}"
              target="${data.Link.target || "_blank"}"
            >
              <span class="card__link-text">View job details</span>
              <i class="card__link-icon" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
      `;
    } else {
      // Qualification card
      return `<div
    class="card card--qualification card--qualification-horiz"
    data-widget="CardTruncate"
  >
  <a class="card--qualification__img" href="${
    data.CallToActionLink.Url
  }" target="${data.CallToActionLink.Target}">
    <picture>
      <source media="(min-width: 1180px)" srcset="${
        data.Image.DesktopUrl
      }" width="372" height="210">
      <source media="(min-width: 768px)" srcset="${
        data.Image.TabletUrl
      }" width="344" height="295">
      <img src="${data.Image.MobileUrl}" alt="${
        data.Image.AlternateText
      }" loading="lazy" width="312" height="230">
    </picture>
    </a>
    <div class="card--qualification__inner">
      <div>
        ${data.Faculty ? `<p class="pill pill--blue">${data.Faculty}</p>` : ""}
        <a class="h3 card--qualification__title" href="${
          data.CallToActionLink.Url
        }" target="${data.CallToActionLink.Target}">
        ${data.Title}
        </a>
        <p class="card__body" data-body="">
        ${data.Description}
        </p>
      </div>
      <div>
        <ul class="pill-container">
          <li class="pill pill--grey2">
            <i class="icon icon-Timer" aria-hidden="true"></i>
            <span>${data.DurationValue}</span>
          </li>
          <li class="pill pill--grey2">
            <i class="icon icon-award" aria-hidden="true"></i>
            <span>${data.CourseType}</span>
          </li>
          ${
            data.StudyOptions.indexOf("Study Online") !== -1 &&
            data.StudyOptions.length === 1
              ? `<li class="pill pill--grey2">
                  <i class="icon icon-globe" aria-hidden="true"></i>
                  <span>Online</span>
                </li>`
              : ""
          }    
        </ul>
        <div class="spacer-base"></div>
        <a class="card__link ${data.CallToActionLink.CssClasses}" href="${
        data.CallToActionLink.Url
      }" target="${data.CallToActionLink.Target}">
          <span class="card__link-text">${data.CallToActionLink.Name}</span>
          <i class="card__link-icon" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  </div>
  `;
    }
  };

  createFilterItem = (child, label, applyImmediately, tag) => {
    const listItem = document.createElement("li");

    const checkboxDiv = document.createElement("div");
    checkboxDiv.classList.add("input-checkbox");
    checkboxDiv.setAttribute("data-filter-group", label.replace(/\s/g, ""));
    checkboxDiv.setAttribute("data-filter-value", child);

    const checkbox = document.createElement("input");
    checkbox.setAttribute("type", "checkbox");
    checkbox.setAttribute("id", `${child}-${tag}`);
    checkbox.setAttribute("value", child);
    checkbox.addEventListener("change", (e) => {
      this.updateFilterSelection(e, label.replace(/\s/g, ""));
    });

    const counterDiv = document.createElement("div");
    counterDiv.classList.add("counter");
    counterDiv.setAttribute(
      "aria-label",
      "Course results after this filter is applied"
    );
    counterDiv.setAttribute("role", "status");
    const numberP = document.createElement("p");
    numberP.innerHTML = "0";
    counterDiv.appendChild(numberP);

    const labelForCheckbox = document.createElement("label");
    labelForCheckbox.setAttribute("for", `${child}-${tag}`);
    labelForCheckbox.textContent = child;

    checkboxDiv.appendChild(checkbox);
    checkboxDiv.appendChild(labelForCheckbox);
    checkboxDiv.appendChild(counterDiv);

    listItem.appendChild(checkboxDiv);

    return listItem;
  };

  createDropdown = (label, children, applyImmediately, tag) => {
    const accordion = document.createElement("div");
    accordion.classList.add("accordion");
    accordion.setAttribute("data-widget", "Expandable");
    accordion.setAttribute("data-isopen", true);

    const trigger = document.createElement("div");
    trigger.classList.add("accordion__trigger");
    trigger.setAttribute("aria-controls", `${label.replace(/\s/g, "")}-${tag}`);
    trigger.setAttribute("data-accordion-trigger", "");

    const button = document.createElement("button");
    button.setAttribute("aria-haspopup", "true");
    button.setAttribute("id", `${label.replace(/\s/g, "")}-label-${tag}`);
    button.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-label", `Filter by ${label}`);

    const labelParagraph = document.createElement("p");
    labelParagraph.classList.add("h6");
    labelParagraph.textContent = label;

    button.appendChild(labelParagraph);

    const chevronIcon = document.createElement("i");
    chevronIcon.setAttribute("aria-hidden", "true");
    chevronIcon.classList.add("icon", "icon-chevron-down");

    trigger.appendChild(button);
    trigger.appendChild(chevronIcon);

    const content = document.createElement("div");
    content.classList.add("accordion__content");
    content.setAttribute("id", `${label.replace(/\s/g, "")}-${tag}`);
    content.setAttribute("role", "region");
    content.setAttribute(
      "aria-labelledby",
      `${label.replace(/\s/g, "")}-label-${tag}`
    );
    content.setAttribute("aria-hidden", "true");

    const ul = document.createElement("ul");
    ul.classList.add("accordion__content-inner", "ul--unstyled");

    children.forEach((child) => {
      const li = this.createFilterItem(child, label, applyImmediately, tag);
      ul.appendChild(li);
    });

    content.appendChild(ul);

    accordion.appendChild(trigger);
    accordion.appendChild(content);

    return accordion;
  };

  getQueryParam = (key) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
  };

  setQueryParam = (key, value) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set(key, value);

    // Replace the current URL with the updated query parameters
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.replaceState({}, "", newUrl);
  };

  readQueryParam = () => {
    this.filterList.forEach((entry) => {
      const filters = this.getQueryParam(entry);
      if (filters?.length) {
        const group = entry;
        const valueArray = this.getQueryParam(group)?.split(",");

        this.filterSelection[group] = valueArray;
        this.tempFilterSelection[group] = valueArray;
        valueArray.forEach((value) => {
          this.addChipHandler(group, value);
        });
      }
    });
  };

  updateQueryParams = () => {
    this.filterList.forEach((entry) => {
      this.setQueryParam(
        entry,
        this.filterSelection[entry] ? this.filterSelection[entry] : ""
      );
    });
  };

  paginationHandler = (data) => {
    this.currentPage = data.detail.value;
    this.updateDom();
  };

  updateDom = () => {
    const cards = [...this.filteredListings];
    const slice = cards.slice(
      (this.currentPage - 1) * this.listingsPerPage,
      this.listingsPerPage * this.currentPage
    );
    const filteredResults = slice
      .map((child) => {
        return this.createCard(child);
      })
      .join("");
    this.results.innerHTML = filteredResults;
    window.blueWidgetReinit(this.results);
  };

  sortCards = (e) => {
    this.sort = e?.target?.value || "A-Z";
    const type = this.sort;
    const currentArray = this.filteredListings;
    const CTA = this.sortSelect
      .closest(".select")
      .querySelector(".select__input-trigger");
    if (CTA) {
      CTA.setAttribute("aria-label", `Current sort order is ${type}`);
    }

    if (type === "A-Z") {
      currentArray.sort((a, b) => {
        const titleA = a.Title.toUpperCase().trim();
        const titleB = b.Title.toUpperCase().trim();
        return titleA.localeCompare(titleB); // Sort alphabetically (A-Z)
      });
    }

    if (type === "Z-A") {
      currentArray.sort((a, b) => {
        const titleA = a.Title.toUpperCase().trim();
        const titleB = b.Title.toUpperCase().trim();
        return titleB.localeCompare(titleA); // Sort alphabetically (Z-A)
      });
    }

    if (type === "Shortest First") {
      currentArray.sort((a, b) => {
        return a.Duration - b.Duration; // Sort by Duration (Shortest First)
      });
    }

    if (type === "Longest First") {
      currentArray.sort((a, b) => {
        return b.Duration - a.Duration; // Sort by Duration (Longest First)
      });
    }

    if (type === "Soonest First") {
      currentArray.sort((a, b) => {
        return this.sortDate(a.EndDate, b.EndDate); // Sort by End Date (Soonest First)
      });
    }

    if (type === "Latest First") {
      currentArray.sort((a, b) => {
        return this.sortDate(b.EndDate, a.EndDate); // Sort by End Date (Latest First)
      });
    }
    this.updateDom();
  };

  filterCards = () => {
    if (this.currentPage > 1) this.currentPage = 1;
    const filterSelection = { ...this.filterSelection };
    const qualifications = [...this.listings];

    if (filterSelection.length === 0) {
      this.filteredListings = [...qualifications];
      this.setPagination(this.filteredListings);
      this.updateDom();
      return;
    }

    const filtered = qualifications.filter((entry) => {
      if (
        filterSelection.Industry &&
        filterSelection.Industry.length > 0 &&
        !filterSelection.Industry.some((filterValue) =>
          entry.Industries.includes(filterValue)
        )
      ) {
        return false;
      }

      if (
        filterSelection.Campus &&
        filterSelection.Campus.length > 0 &&
        !filterSelection.Campus.some((filterValue) =>
          entry.StudyOptions.includes(filterValue)
        )
      ) {
        return false;
      }

      if (
        filterSelection.CourseType &&
        filterSelection.CourseType.length > 0 &&
        !filterSelection.CourseType.includes(entry.CourseType)
      ) {
        return false;
      }

      if (
        filterSelection.Faculty &&
        filterSelection.Faculty.length > 0 &&
        !filterSelection.Faculty.includes(entry.Faculty)
      ) {
        return false;
      }

      if (
        filterSelection.Province &&
        filterSelection.Province.length > 0 &&
        !filterSelection.Province.includes(entry.Province)
      ) {
        return false;
      }

      return true;
    });

    this.filteredListings = [...filtered];
    this.setPagination(this.filteredListings);
    this.sortCards();
    this.updateDom();
    this.toggleTitlesHandler();
    this.setCheckboxStates();
    this.foundText.querySelector("span").innerHTML = filtered.length;
  };

  setListItemIndicatorsHandler = () => {
    const filterCards = this.filteredListings;
    const checkboxes = document.querySelectorAll(
      ".input-checkbox[data-filter-group]"
    );

    checkboxes.forEach((item) => {
      const group = item.getAttribute("data-filter-group");
      const value = item.getAttribute("data-filter-value");

      let groupName = group;
      if (group === "Industry") {
        groupName = "Industries";
      } else if (group === "Campus") {
        groupName = "StudyOptions";
      }

      const results = filterCards.filter((entry) => {
        const obj = entry[groupName];
        if (obj) {
          if (Array.isArray(obj)) {
            return entry[groupName].includes(value);
          } else {
            return entry[groupName] === value;
          }
        }
      });
      if (results.length === 0) {
        item.querySelector("input").setAttribute("disabled", "");
      } else {
        item.querySelector("input").removeAttribute("disabled");
      }
      const text = item.querySelector(".counter");

      if (text) {
        text.querySelector("p").innerHTML = results.length;
      }
    });
  };

  addChipHandler = (group, label) => {
    const newchip = this.createChip(group, label, { isMobile: false });
    const newMobileChip = this.createChip(group, label, { isMobile: true });
    this.chiplist.appendChild(newchip);
    this.chipListMobile.appendChild(newMobileChip);
  };

  removeChipHandler = (label) => {
    const elem = document.getElementById(`filterchip-${label}`);
    if (elem) {
      elem.parentElement.removeChild(elem);
    }
  };

  chipClickHandler = (group, label) => {
    this.removeChipHandler(label);
    this.removeChipHandler(`mobile-${label}`);
    const inputs = this.filters.querySelectorAll(`input[value="${label}"]`);
    inputs.forEach((elm) => {
      elm.checked = false;
    });

    const index = this.filterSelection[group].indexOf(label);
    if (index !== -1) {
      this.filterSelection[group].splice(index, 1);
    }

    this.filterCards();
    this.setListItemIndicatorsHandler();
    this.updateQueryParams();
  };

  setPagination = (array) => {
    const totalpages = Math.ceil(array.length / this.listingsPerPage);
    this.pagination.setAttribute("data-current-page", this.currentPage);
    this.pagination.setAttribute("data-pages", totalpages);
    this.pagination.addEventListener(
      "pagination-value-changed",
      this.paginationHandler
    );
  };

  initDropdowns = () => {
    if (this.provinceFilters) {
      this.addDropdownForFilterCategory("Province", this.provinceFilters);
    }
    if (this.campusFilters) {
      this.addDropdownForFilterCategory("Campus", this.campusFilters);
    }
    if (this.industryFilters) {
      this.addDropdownForFilterCategory("Industry", this.industryFilters);
    }
    if (this.courseTypeFilters) {
      this.addDropdownForFilterCategory("Course Type", this.courseTypeFilters);
    }
    if (this.facultyFilters) {
      this.addDropdownForFilterCategory("Faculty", this.facultyFilters);
    }
  };

  addDropdownForFilterCategory = (categoryName, filters) => {
    if (filters.length > 0) {
      const dropdown = this.createDropdown(
        categoryName,
        filters,
        true,
        "desktop"
      );
      this.filters.appendChild(dropdown);
      const mobileDropdown = this.createDropdown(
        categoryName,
        filters,
        false,
        "mobile"
      );
      this.mobileFilters.appendChild(mobileDropdown);
    }
  };

  setCheckboxStates = () => {
    const combinedArray = Object.values(this.filterSelection).flat();
    const checkedCheckboxes = Array.from(
      document.querySelectorAll(".input-checkbox input:checked")
    );

    checkedCheckboxes.forEach((input) => {
      const value = input.getAttribute("value");
      if (!combinedArray.includes(value)) {
        input.checked = false;
      }
    });

    combinedArray.forEach((entry) => {
      const matchingCheckboxes = document.querySelectorAll(
        `.input-checkbox input[value="${entry}"]`
      );

      matchingCheckboxes.forEach((checkbox) => {
        if (!checkbox.checked) {
          checkbox.checked = true;
        }
      });
    });
  };

  toggleTitlesHandler = () => {
    if (this.chiplist.querySelector("li")) {
      this.h4Title.classList.add("d-none");
      this.h4TitleMobile.classList.add("d-none");
      this.h6Title.classList.remove("d-none");
      this.h6TitleMobile.classList.remove("d-none");
    } else {
      this.h4Title.classList.remove("d-none");
      this.h4TitleMobile.classList.remove("d-none");
      this.h6Title.classList.add("d-none");
      this.h6TitleMobile.classList.add("d-none");
    }
  };

  clearFiltersHandler = () => {
    this.filterSelection = {};
    this.tempFilterSelection = {};
    this.chiplist.innerHTML = "";
    const inputs = document.querySelectorAll(".input-checkbox input");
    if (inputs) {
      inputs.forEach((dropdown) => {
        dropdown.checked = false;
      });
    }
    this.filterCards();
    this.setListItemIndicatorsHandler();
  };

  updateFilterSelection = (e, label) => {
    const isChecked = e.target.checked;
    if (label in this.tempFilterSelection) {
      if (
        isChecked &&
        this.tempFilterSelection[label].indexOf(e.target.value) === -1
      ) {
        this.tempFilterSelection[label].push(e.target.value);
        this.addChipHandler(label, e.target.value);
      }
      if (!isChecked) {
        const index = this.tempFilterSelection[label].indexOf(e.target.value);
        this.removeChipHandler(e.target.value);
        this.removeChipHandler(`mobile-${e.target.value}`);
        if (index !== -1) {
          this.tempFilterSelection[label].splice(index, 1);
        }
      }
    } else if (isChecked) {
      this.tempFilterSelection[label] = [e.target.value];
      this.addChipHandler(label, e.target.value);
    }

    this.applyFilterHandler();
  };

  applyFilterHandler = () => {
    Object.assign(this.filterSelection, this.tempFilterSelection);

    this.filterCards();
    this.setListItemIndicatorsHandler();
    this.updateQueryParams();
  };

  toggleMobileMenuHandler = () => {
    if (this.mobileMenu) {
      const isOpen = this.mobileMenu.classList.contains("isOpen");
      if (isOpen) {
        this.mobileMenu.classList.remove("isOpen");
        this.scrollLockHandler(false);
        window.removeEventListener(
          "resize",
          this.toggleMobileMenuHandler,
          false
        );
      } else {
        this.mobileMenu.classList.add("isOpen");
        this.scrollLockHandler(true);
        window.addEventListener("resize", this.toggleMobileMenuHandler, false);
      }
    }
  };

  scrollLockHandler(lock) {
    const doc = document.body;
    const main = document.querySelector("main");
    if (lock) {
      this.scrollPos = window.scrollY;
      doc.style.position = "fixed";
      doc.style.overflow = "hidden";
      doc.style.height = "100vh";
      main.style.marginTop = `-${this.scrollPos}px`;
    } else {
      doc.style.position = "";
      doc.style.overflow = "";
      doc.style.height = "";
      main.style.marginTop = "";
      window.scrollTo(0, this.scrollPos);
    }
  }

  focusTrap(lock) {
    if (lock) {
      const rootElm = this.mobileMenu.querySelector(
        "content-listing-mobile__content"
      );
      rootElm.focus({ focusVisible: true });
      const tabbableElements = this.mobileMenu.querySelectorAll(
        "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
      );
      const lastItem = tabbableElements[tabbableElements.length - 1];
      lastItem.addEventListener("blur", () => {
        rootElm.focus({ focusVisible: true });
      });
    }
  }

  formatDate(dateString) {
    const dateArray = dateString.split("/");
    const date = new Date(dateArray[2], dateArray[1] - 1, dateArray[0]);
    const options = { day: "numeric", month: "long", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options);

    return formattedDate;
  }

  sortDate(dateA, dateB) {
    // Convert to Date objects
    const datePartsA = dateA.split("/");
    const formattedDateA = new Date(
      datePartsA[2],
      datePartsA[1] - 1,
      datePartsA[0]
    ); // Year, Month (0-indexed), Day

    const datePartsB = dateB.split("/");
    const formattedDateB = new Date(
      datePartsB[2],
      datePartsB[1] - 1,
      datePartsB[0]
    ); // Year, Month (0-indexed), Day

    // Compare the two dates
    return formattedDateA - formattedDateB;
  }

  init() {
    if (this.sortSelect) {
      this.sortSelect.addEventListener("change", (e) => {
        this.sortCards(e);
      });
    }

    if (this.dataClearFilters) {
      this.dataClearFilters.forEach((element) => {
        element.addEventListener("click", this.clearFiltersHandler);
      });
    }

    if (this.mobileTrigger) {
      this.mobileTrigger.addEventListener(
        "click",
        this.toggleMobileMenuHandler
      );
    }
    if (this.mobileApply) {
      this.mobileApply.addEventListener("click", this.applyFilterHandler);
      this.mobileApply.addEventListener("click", this.toggleMobileMenuHandler);
    }
    if (this.closeFiltersBtn) {
      this.closeFiltersBtn.addEventListener(
        "click",
        this.toggleMobileMenuHandler,
        false
      );
    }
    this.readQueryParam();
    this.initDropdowns();
    this.filterCards();
    this.sortCards();
    this.updateDom();
    this.setListItemIndicatorsHandler();
    window.blueWidgetReinit(this.filters);
    window.blueWidgetReinit(this.mobileFilters);
    window.blueWidgetReinit(this.results);
  }

  beforeRemove() {
    if (this.sortSelect) {
      this.sortSelect.removeEventListener("change", (e) => {
        this.sortCards(e);
      });
    }

    if (this.dataClearFilters) {
      this.dataClearFilters.forEach((element) => {
        element.removeEventListener("click", this.clearFiltersHandler);
      });
    }

    if (this.mobileTrigger) {
      this.mobileTrigger.removeEventListener(
        "click",
        this.toggleMobileMenuHandler
      );
    }

    if (this.mobileApply) {
      this.mobileApply.removeEventListener("click", this.applyFilterHandler);
      this.mobileApply.removeEventListener(
        "click",
        this.toggleMobileMenuHandler
      );
    }

    if (this.closeFiltersBtn) {
      this.closeFiltersBtn.removeEventListener(
        "click",
        this.toggleMobileMenuHandler
      );
    }
  }
}

export default ContentListing;
